<template>
  <div>
    <div class="room-info-container">
      <div class="info-title-container">
        <img v-if="!isMobile" src="@/assets/images/camstudy/logo_gooroomee_blue_016FF2.svg" class="info-title-logo">
        <div class="room-title">{{ room.title || camStudyInfo.studyTitle }}</div>
        <div class="line"></div>
        <div class="person-count">{{ roomUserCount }}</div>
        <div class="info-icon-container">
          <a href="https://webchat.thecloudgate.io/webChat?brandKey=MUxOPwt-6RJvxjfghABUmA&channelType=scenario&scenarioId=MzI3OQ" target="_blank">
            <img src="@/assets/images/camstudy/ico_help_white.svg" alt="문의" />
          </a>
          <div class="toggle-open-detail" :class="{active: isOpenDetail}" @click="onToggleOpenDetail"></div>
        </div>
      </div>
  <!--    <div v-if="isOpenMoreDetailModal" class="more-detail-container" v-click-outside="onCloseMoreDetailModal">-->
  <!--      <div class="absolute top-4 right-4" @click="onCloseMoreDetailModal">-->
  <!--        <img src="@/assets/images/camstudy/ico_close_white.svg" alt="닫기" />-->
  <!--      </div>-->
  <!--      <div class="more-detail-title">차단 조치</div>-->
  <!--      <div class="more-detail-content">-->
  <!--        자기 또는 다른 사람의 성적 욕망을 유발하거나 만족시킬 목적으로 전화, 우편, 컴퓨터, 그 밖의 통신매체를 통하여 성적 수치심이나 혐오감을 일으키는 말, 음향, 글, 그림, 영상 또는 물건을 상대방에게 도달하게 한 사람은-->
  <!--        <strong>성폭력 범죄의 처벌 등에 관한 특례법 제 13조(통신매체를 이용한 음란행위)</strong>에 의하여 2년 이하의 징역 또는 2천만원 이하의 벌금에 처할 수 있습니다.-->
  <!--      </div>-->
  <!--    </div>-->
    </div>
    <transition name="menu-slide-top-bottom" tag="div">
      <div v-if="isOpenDetail" class="info-detail-container" v-click-outside="isMobile ? null : onCloseOpenDetail" @click.stop>
        <div class="info-detail-container-title" v-if="!isMobile">
          <div class="close-btn" @click="onCloseOpenDetail"></div>
          <div>스터디 정보</div>
        </div>
        <div class="column-container">
          <div class="column-title">{{ $t('camstudy.coordi.roomInfo.studyTitle') }}</div>
          <div class="column-message">{{ room.title || camStudyInfo.studyTitle }}</div>
        </div>
        <div class="column-container">
          <div class="column-title">{{ $t('camstudy.coordi.roomInfo.host') }}</div>
          <img v-if="camStudyUser.profileImageUrl" class="column-profile-image" :src="camStudyUser.profileImageUrl || ''" alt="image" />
          <div v-else class="profile-image-none"></div>
          <div class="column-message">{{ camStudyUser?.username }}</div>
        </div>
        <div class="column-container">
          <div class="column-title">{{ $t('camstudy.coordi.roomInfo.capacity') }}</div>
          <div class="column-message"> {{ $t('camstudy.coordi.roomInfo.participants', {'0': room.maxCnt }) }}</div>
        </div>
        <div class="column-container">
          <div class="column-title">{{ $t('camstudy.coordi.roomInfo.period') }}</div>
          <div class="column-message"> {{ formatStartDate }} ~ {{ formatEndDate }}</div>
        </div>
        <div class="column-container">
          <div class="column-title">{{ $t('camstudy.coordi.roomInfo.notice') }}</div>
          <div class="column-message">{{ camStudyInfo.studyContent }}</div>
        </div>
        <div class="warning-container">
          <div class="warning-title">{{ $t('camstudy.coordi.roomInfo.reportTitle') }}</div>
          <div class="warning-message">{{ $t('camstudy.coordi.roomInfo.reportMessage') }}</div>
          <div class="more-detail" @click="onOpenMoreDetailModal">{{ $t('camstudy.coordi.roomInfo.moreDetail.title') }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import {Device} from "@/utils"

export default {
  name: 'CamstudyRoomInfo',
  // props: {
  //   roomInfo: Object,
  // },
  data(){
    return {
      isOpenDetail: false,
      hostUserId: '',
    }
  },
  watch: {
    '$parent.isOpenControlMenu': {
      handler(){
        this.isOpenDetail = false;
      }
    },
    isOpenDetail(){
      if(this.isMobile){
        const videoContainer = document.querySelector('.mobile-video-scroll');
        if(!videoContainer){
          return;
        }
        videoContainer.style.transition = '0.3s';
        if(this.isOpenDetail === true){
          videoContainer.style.background = 'rgb(0, 0, 0)';
          videoContainer.style.opacity = 0.5;
        }else{
          videoContainer.style.opacity = 1;
          videoContainer.style.background = 'transparent';
        }
      }
      if(this.isOpenDetail) {
        this.setHostUserId()
      }
    }
  },
  created() {
  },
  computed: {
    ...mapGetters('room', [
        'room'
    ]),
    ...mapGetters('user', [
      'roomUserCount',
      'roomUserListSpeaker'
    ]),
    ...mapGetters('camstudy', [
        'camStudy',
        'getCamStudyUser',
    ]),
    camStudyInfo() {
      return this.camStudy;
    },
    camStudyUser() {
      return this.getCamStudyUser(this.hostUserId || this.camStudyInfo.userId);
    },
    formatStartDate() {
      return this.formatDate(this.room.startDate);
    },
    formatEndDate() {
      return this.formatDate(this.room.endResvDate);
    },
    isMobile(){
      return Device.isMobile()
    }
  },
  methods: {
    ...mapActions('user',[
        'getSpeakerUser',
    ]),
    onToggleOpenDetail(){
      this.isOpenDetail = !this.isOpenDetail;
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    onOpenMoreDetailModal(){
      this.$camsAlert({
        title: this.$t('camstudy.coordi.roomInfo.moreDetail.blockTitle'),
        text: this.$t('camstudy.coordi.roomInfo.moreDetail.blockMsg'),
        onlyOk: true,
      })
    },
    onCloseOpenDetail(){
      this.isOpenDetail = false;
    },
    async setHostUserId() {
      if(this.roomUserListSpeaker.length) {
        this.hostUserId = this.roomUserListSpeaker[0].userId
      } else {
        this.hostUserId = (await this.getSpeakerUser())?.userId || ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
[grm-device-mobile]{
  .room-info-container{
    position: absolute;
    z-index: 2;
    background: rgba(31, 31, 31, 0.9);
  }
  .info-detail-container{
    @media(orientation: portrait){
      max-height: calc(100dvh - 104px);
    }
    @media(orientation: landscape){
      max-height: calc(100dvh - 148px);
    }
    left: 50%;
    top: 50px;
    transform: translateX(-50%);
  }
}
html:not([grm-device-mobile]){
  .room-info-container {
    display: flex;
    justify-content: center;
    background: rgba(31, 31, 31, 1);

    .info-title-container {
      max-width: 1024px;
      padding: 14px 16px;
      width: 100%;
      line-height: 25px;

      .info-title-logo{
        width: 40px;
        height: 24px;
        margin-right: 4px;
      }
    }
  }
  .info-detail-container{
    right: 0;
    top: 0;
    bottom: 0;
    width: 360px;
    border-left: 0.5px solid rgba(255, 255, 255, 0.20);
    background: #1A1A1A;
  }
}
.room-info-container{
  transform: translateY(-100%);
  opacity: 0;
  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  line-height: 1.5;
  @media(orientation: portrait){
    width: 100%;
    left: 0;
    top: 0;
  }
  @media(orientation: landscape){
    right: env(safe-area-inset-right);
    left: env(safe-area-inset-left);
    top: 0;
  }
  color: #fff;
  // 기존 헤더로 인한 임시 처리
  //z-index: 99;

  .info-title-container{
    position: relative;
    display: flex;
    align-items: center;
    height: 50px;
    padding: 9px 12px 9px 16px;
    gap: 12px;    
    font-size: 16px;
    font-weight: bold;    
    z-index: 2;

    .line {
      background: rgba(255,255,255,0.1);
      height: 14px;
      width: 1px;
    }
    .person-count {
      font-size: 14px;
      color: #016FF2;
      padding-left: 20px;
      background: url('~@/assets/images/camstudy/person.svg') no-repeat center left;
    }
  }

  .info-icon-container{
    position: absolute;
    right: 20px;
    top: 25px;
    transform: translateY(-50%);
    display: flex;
    gap: 4px;
    z-index: 2;

    a {
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .toggle-open-detail {
    width: 32px;
    height: 32px;
  }

  .detail-cover {
    &.active{
      width: 100%;
      background: rgba(0, 0, 0, 0.5);

      @media(orientation: portrait){
        height: calc(100dvh - 104px);
      }

      @media(orientation: landscape){
        height: calc(100dvh - 148px);
      }
    }
  }
}
.visible > .room-info-container{
  transform: translateY(0);
  opacity: 1;
}
[grm-device-mobile]{
  .toggle-open-detail {
    background: url("~@/assets/images/camstudy/ico_arrowLineTop_white.svg") no-repeat center center / 24px auto;
    transform: rotate(180deg);
    transform-origin: center center;
    transition: 200ms ease-out;

    &.active{
      transform: rotate(0);
    }
  }
  .info-detail-container{
    padding: 30px 20px;
    width: calc(100% - env(safe-area-inset-right) - env(safe-area-inset-left));
  }
}
html:not([grm-device-mobile]){
  .toggle-open-detail {
    background: url("~@/assets/images/camstudy/ico_room_info_white.svg") no-repeat center center / 24px auto;
  }
  .info-detail-container{
    padding: 0 20px 20px;
    width: 100%;
    max-width: 360px;

    .info-detail-container-title{
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 16px;

      font-size: 14px;
      position: relative;

      .close-btn{
        background: url("~@/assets/images/camstudy/ico_close_white.svg") center no-repeat;
        width: 32px;
        height: 32px;
        position: absolute;
        left: 0;
      }
    }
  }
}
.info-detail-container{
  &::-webkit-scrollbar{
    display: none;
  }
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: rgba(31,31,31,0.8);
  backdrop-filter: blur(10px);
  color: white;
  overflow: scroll;
  position: absolute;
  z-index: 999;

  .column-container{
    display: flex;
  }

  .column-title {
    width: 100px;
    font-weight: 700;
    font-size: 12px;
    line-height: 150%;
    flex-shrink: 0;
  }
  .column-message {
    font-size: 12px;
    line-height: 150%;
  }
  .warning-title{
    font-weight: 700;
    font-size: 12px;
    line-height: 150%;
    color: #FF5353;
    padding-left: 22px;
    background: url('~@/assets/images/camstudy/warning_declaration.svg') no-repeat center left;
  }
  .warning-message{
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: #FF5353;
    margin-top: 6px;
  }
  .more-detail{
    font-size: 12px;
    line-height: 150%;
    text-decoration: underline;
    text-decoration-style: solid;
    margin-top: 6px;
  }
  .column-profile-image, .profile-image-none{
    width: 18px;
    height: 18px;
    border-radius: 50%;
    margin-right: 6px;
  }
  .profile-image-none{
    background: url("~@/assets/images/user_profile.svg") no-repeat;
    background-size: auto 18px;
  }
}
.more-detail-container{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 360px;
  padding: 30px;
  background-color: #141414;
  border-radius: 4px;
  color: #fff;
  box-sizing: border-box;

  .more-detail-title{
    text-align: center;
    font-size: 20px;
    line-height: 24px;
  }
  .more-detail-content{
    margin-top: 24px;
    font-size: 14px;
    line-height: 24px;
    word-break: keep-all;
    text-align: left;
  }
}
</style>